/** Mirrors `server/src/auth/roles.js`. The server is still the authority. */

export const ROLES = ['admin', 'vendor', 'customer', 'user'];

export const ROLE_LABELS = {
  admin: 'Admin',
  vendor: 'Vendor Staff',
  customer: 'Customer Staff',
  user: 'User (read only)',
};

export const ROLE_DESCRIPTIONS = {
  admin: 'Full access, including User Management.',
  vendor: 'Catalogs, vendors, stock in and reports.',
  customer: 'Customers, invoices, pricing and reports.',
  user: 'Dashboard and reports only.',
};

export const ROLE_MODULES = {
  admin: [
    'Product Name', 'Texture Management', 'Length Management', 'Color Management',
    'Vendor Management', 'Customer Management', 'Stock In Management',
    'Stock Out / Invoice', 'Price Management', 'Reports', 'User Management',
  ],
  vendor: [
    'Product Name', 'Texture Management', 'Length Management', 'Color Management',
    'Vendor Management', 'Stock In Management', 'Reports',
  ],
  customer: ['Customer Management', 'Stock Out / Invoice', 'Price Management', 'Reports'],
  user: ['Reports'],
};

export function defaultModulesFor(role) {
  return [...(ROLE_MODULES[role] || ROLE_MODULES.user)];
}

/**
 * Admins always pass. This has to match the server's `hasModule` exactly —
 * otherwise the sidebar hides a page the API would happily have served, or
 * shows one it will refuse.
 */
export function hasModule(user, moduleName) {
  if (!user) return false;
  if (user.role === 'admin') return true;
  return Array.isArray(user.modules) && user.modules.includes(moduleName);
}
